import React, { createContext, useContext, FC } from 'react';
import { RodRequest } from '@bechtel/types';
import { noop } from 'lodash';

interface RodRequestSubscriptionContextProps {
  rodRequestId: RodRequest['id'];
  setRodRequestId: React.Dispatch<React.SetStateAction<RodRequest['id']>>;
}

const RodRequestSubscriptionContextPrivate = createContext<RodRequestSubscriptionContextProps>({
  rodRequestId: '',
  setRodRequestId: noop,
});

const { Provider } = RodRequestSubscriptionContextPrivate;

export const useRodRequestSubscriptionContext = () => {
  return useContext(RodRequestSubscriptionContextPrivate);
};

export const RodRequestSubscriptionContext: FC<RodRequestSubscriptionContextProps> = ({
  children,
  ...subscriptionContextProps
}) => {
  return <Provider value={subscriptionContextProps}>{children}</Provider>;
};
